module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAUCAMAAAATIyWrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFzNvT0OXb2OriydLN8/Pz+/z86vPt29zc6Ojp4eHi9fj24u/n7/by0dHR////3u7pmAIdTQAAALdJREFUeNqUk9kCgyAMBJNAIIrg//9tA9YLqdB9nmEJB6R/ws4FGCIXF8JKiLTS/GrMumSgQn5DnGAI3HmESeDSXKob4B40MU6cDVbqN3cUKB99KrsK60CKIHYzaFCYOO9+zCAdYeOLsXQN2CY4jK6AWeDTCAMNXg5BDewZJsr1fqE3BcFdSBCaR4MIJcZUDWo4ekL5ss7YyrCmAV3iKyGBtCjvRcRq+PmyYa4g7v0uSNyHbvkIMAA92zBLbkH1ZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/TN.png
// module id = q52T
// module chunks = 1